var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMoreMenu = function SvgMoreMenu(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134.8,
    cy: 500,
    r: 133.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 865.2,
    cy: 500,
    r: 133.8,
    transform: "rotate(-45.001 865.179 500.007)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M506.8 366.2C432 366.2 373 427.4 373 500c0 74.9 61.2 133.8 133.8 133.8 74.9 0 133.8-61.2 133.8-133.8s-58.9-133.8-133.8-133.8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMoreMenu);
export default ForwardRef;